import { BrowserRouter } from "./RoutingModules";

export const Router = ({...props}) => {
    const {children} = props;
    return (
        <BrowserRouter>
            {children}
        </BrowserRouter>
    )
}